import { useState } from 'react';
import { Alert, Backdrop, Box, Breadcrumbs, Button, CircularProgress, IconButton, Link, Paper, TextField, Typography } from '@mui/material';
import { styled } from '@mui/system';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { generateRandomSalt } from '../../../utils/Generators';
import { CassinoAPI } from '../../../apis/CassinoAPI';


const Container = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    gap: 2,
});

const ReturnContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
});

const AddUserForm = styled(Paper)({
    marginTop: '12px',
    padding: '12px',
});

const Title = styled(Typography)({
    fontWeight: '600',
});

const SubmitContainer = styled(Box)({
    display: 'flex',
    gap: 8,
});


const AddCassinoView = () => {
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState({
        visible: false,
        text: []
    });
    const [newCassino, setNewCassino] = useState({
        name: '',
        authKey: '',
    });
    const handleInputChange = (event) => {
        setNewCassino({ ...newCassino, [event.target.name]: event.target.value })
    }


    const handleSubmitUser = () => {
        // console.log(newCassino);
        setAlert({ ...alert, visible: false });

        if (newCassino.name.length < 5) {
            setAlert({ ...alert, visible: true, text: ['Nome deve possuir pelo menos 5 caracteres.'] });
            return;
        }

        if (newCassino.authKey.length < 10) {
            setAlert({ ...alert, visible: true, text: ['Você deve gerar uma authKey.'] });
            return;
        }

        CassinoAPI.postCassino(newCassino)
            .then((res) => {
                console.log(res);
                setNewCassino({
                    name: '',
                    authKey: '',
                });
                setAlert({ ...alert, visible: false });
                navigate(-1);
            })
            .catch((e) => {
                console.log(e);
                setIsLoading(false);
                setAlert({ visible: true, text: e?.response?.data?.Errors });
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const handleGenSalt = () => {
        setNewCassino({ ...newCassino, ['authKey']: generateRandomSalt(10) });
    }

    return (
        <Container mt={-2}>
            <ReturnContainer ml={-3} mb={2}>
                <IconButton aria-label="voltar" onClick={() => navigate(`/admin`)}>
                    <ArrowBackIosIcon />
                </IconButton>
                <Typography color="text.primary">Voltar</Typography>
            </ReturnContainer>
            <Breadcrumbs aria-label="breadcrumb">
                <Link
                    underline="hover"
                    color="inherit"
                    href="/admin"
                >
                    Home
                </Link>
                <Link
                    underline="hover"
                    color="inherit"
                    href="/admin/gestao"
                >
                    Gestão
                </Link>
                <Link
                    underline="hover"
                    color="inherit"
                    href="/admin/gestao/cassinos"
                >
                    Cassinos
                </Link>
                <Typography color="text.primary">Novo</Typography>
            </Breadcrumbs>

            <AddUserForm>
                <Title component='h1'>Adicionar cassino</Title>
                <Box my={3}>
                    <Grid container spacing={2}>
                        <Grid xs={12} md={6}>
                            <TextField
                                id="input-name"
                                name='name'
                                label="Nome"
                                variant="outlined"
                                fullWidth
                                value={newCassino.name}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid xs={12} md={6}>
                            <Box sx={{ display: 'flex' }}>
                                <TextField
                                    id="input-authKey"
                                    name='authKey'
                                    label="Authkey"
                                    variant="outlined"
                                    fullWidth
                                    disabled
                                    value={newCassino.authKey}
                                />
                                <Button variant="contained" onClick={handleGenSalt}>Gerar</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                {alert.visible &&
                    <Box my={2}>
                        <Alert severity="error">
                            <ul>
                                {alert.text.map((item, index) =>
                                    <li key={'error-' + index}>{item}</li>
                                )}
                            </ul>
                        </Alert>
                    </Box>
                }

                <SubmitContainer>
                    <Button variant="contained" onClick={handleSubmitUser}>Adicionar</Button>
                    <Button variant="outlined" onClick={() => navigate(-1)}>Voltar</Button>
                </SubmitContainer>
            </AddUserForm>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
                onClick={() => setIsLoading(false)}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Container>
    )
}
export default AddCassinoView;